import { forwardRef, useState } from "react";

import { EyeIcon, EyeSlashIcon } from "@phosphor-icons/react";

import Input, { InputSize, type InputProps } from "./Input";

type PasswordInputProps = Omit<InputProps<string>, "type" | "parse" | "action">;

interface PasswordInputState {
  showPassword: boolean;
}

const DEFAULT_STATE: PasswordInputState = {
  showPassword: false,
};

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (
    {
      size = InputSize.MEDIUM,
      value,
      placeholder,
      label,
      leading,
      error,
      isRequired,
      isDisabled,
      autoFocus,
      onChange,
      width,
      fillWidth,
      onKeyDown,
      onBlur,
      onFocus,
    },
    ref,
  ) => {
    const [state, setState] = useState<PasswordInputState>(DEFAULT_STATE);

    return (
      <Input
        ref={ref}
        parse={String}
        onChange={onChange}
        size={size}
        type={state.showPassword ? "text" : "password"}
        value={value}
        placeholder={placeholder}
        label={label}
        leading={leading}
        trailing={{
          icon: state.showPassword ? EyeSlashIcon : EyeIcon,
          onClick: () => setState({ ...state, showPassword: !state.showPassword }),
          isDisabled,
        }}
        error={error}
        isRequired={isRequired}
        isDisabled={isDisabled}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        onFocus={onFocus}
        width={width}
        fillWidth={fillWidth}
      />
    );
  },
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
